
import { create } from "zustand";
import { devtools } from "zustand/middleware";




const storeApi = (set) => ({
    imagen: undefined,
    
    valorImagen: (valor) => {
        set({ imagen: valor });
    },
});



export const useImagenStore = create(devtools(storeApi));